import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { persistor } from "../store";

export function useLogOut() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const logOut = () => {

        dispatch({ type: 'reset' });
        persistor.purge();
        localStorage.clear();
        window.location.reload();
        // navigate("/signin");

    }

    return [logOut];
}
